import type { HTMLAttributes } from "react";
// eslint-disable-next-line no-restricted-imports
import { Menu as MenuBase } from "@base-ui/react/menu";
import { SwitchIndicator } from "@design-system/Switch/SwitchIndicator";
import {
    MenuItemContent,
    menuItemClassName,
    renderRowWithTooltip,
} from "./MenuItemContent";
import type { MenuToggleItemProps } from "./Menu.types";
import styles from "./MenuItem.module.scss";

const renderSwitch = (
    props: HTMLAttributes<HTMLSpanElement>,
    state: MenuBase.CheckboxItemIndicator.State,
) => (
    <span {...props}>
        <SwitchIndicator checked={state.checked} disabled={state.disabled} />
    </span>
);

/**
 * A setting row: its label, then a switch at the row's right edge. The row
 * is the `menuitemcheckbox` control and the switch only paints its state;
 * the menu stays open unless `closeOnClick` is set.
 */
export const MenuToggleItem = ({
    children,
    checked,
    onCheckedChange,
    disabled = false,
    disabledReason,
    tooltip,
    closeOnClick = false,
    className,
    ref,
    "data-forced-state": forcedState,
}: MenuToggleItemProps) => (
    <MenuBase.CheckboxItem
        ref={ref}
        checked={checked}
        onCheckedChange={onCheckedChange}
        disabled={disabled}
        closeOnClick={closeOnClick}
        className={menuItemClassName({
            hasDescription: false,
            isDestructive: false,
            className,
        })}
        data-forced-state={forcedState}
        render={renderRowWithTooltip({
            isDisabled: disabled,
            disabledReason,
            tooltip,
        })}
    >
        <MenuItemContent
            trailing={
                <MenuBase.CheckboxItemIndicator
                    keepMounted
                    className={styles.itemSwitch}
                    render={renderSwitch}
                />
            }
        >
            {children}
        </MenuItemContent>
    </MenuBase.CheckboxItem>
);
